import _ from 'lodash';

const AUTH_CREDENTIALS_NOT_PROVIDED = 'Authentication credentials were not provided.';

export function isSessionExpired(error) {
    const detail = _.get(error, 'response.data.detail');
    return error.response && error.response.status === 403 && detail === AUTH_CREDENTIALS_NOT_PROVIDED;
}
